import {ShipmentProcessTypeDto} from "../../api/fms";

export function isStorageTransferOrInternalProcess(process: ShipmentProcessTypeDto): boolean {
    const storageTransferProcessTypes = [
        ShipmentProcessTypeDto.INTERNAL,
        ShipmentProcessTypeDto.STORAGE_TRANSFER,
        ShipmentProcessTypeDto.STORAGE_TRANSFER_SCA,
        ShipmentProcessTypeDto.STORAGE_TRANSFER_SCA_FINISH,
    ]

    return storageTransferProcessTypes.indexOf(process) !== -1
}
